import { render, staticRenderFns } from "./part2.vue?vue&type=template&id=6528d926&scoped=true"
import script from "./part2.vue?vue&type=script&lang=js"
export * from "./part2.vue?vue&type=script&lang=js"
import style0 from "./part2.vue?vue&type=style&index=0&id=6528d926&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6528d926",
  null
  
)

export default component.exports